import '../styles/TransferCompletionBand.css';
import React from 'react';

const DESTINATIONS = [
  { label: 'Review transfer history', href: '/transfer-history', value: '/transfer-history' },
  { label: 'Back to dashboard', href: '/dashboard', value: '/dashboard' },
];

function TransferCompletionBand({ completed = false }) {
  if (!completed) return null;

  return (
    <section className="tcb-root" aria-labelledby="tcb-heading">
      <div className="tcb-plate">
        <div className="tcb-inner">
          <div className="tcb-heading-block">
            <p className="tcb-micro">Transfer complete</p>
            <h2 className="tcb-heading" id="tcb-heading">
              Continue from here
            </h2>
            <p className="tcb-note">
              Your transfer page stays open regardless of the submission result. Use the
              destinations below to review your records or return to your instrument panel.
            </p>
          </div>

          <ul className="tcb-destinations" aria-label="Outbound destinations">
            {DESTINATIONS.map((destination) => (
              <li className="tcb-destination" key={destination.href}>
                <a className="tcb-link" href={destination.href}>
                  <span className="tcb-link-label">{destination.label}</span>
                  <span className="tcb-link-value">{destination.value}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default TransferCompletionBand;